import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


export default function LineMonthSeries({ data = [], year }) {
const labels = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
const totalsByMonth = new Array(12).fill(0);
data.forEach(r => { totalsByMonth[r.mes - 1] = parseFloat(r.total || 0); });

const chartData = {
labels,
datasets: [{
label: `Recaudación ${year}`,
data: totalsByMonth,
borderColor: '#007bff',
backgroundColor: 'rgba(0, 123, 255, 0.3)',
tension: 0.2
}]
};


const options = {
responsive: true,
plugins: {
legend: { position: 'top' },
title: { display: true, text: 'Recaudación mensual' }
}
};


return <div style={{ height: '300px' }}><Line data={chartData} options={options} /></div>;
}